/* ---------------------------------------------------- */
// AJAX namespace

// ** default ** //
var pagedefault = Barba.BaseView.extend({
	namespace: "pagedefault",

	onEnter: function() {},
	onEnterCompleted: function() {
		//loadGoogleMap();

		// add class on the body to anim the content
		setTimeout(function() {
			theBody.classList.remove("page-transition");
			theBody.classList.add("page-show");
		}, 350);
	},
	onLeave: function() {
		// A new Transition toward a new page has just started.
		setTimeout(function() {
			theBody.classList.remove("page-show");
			theBody.classList.add("page-transition");
		}, 150);
	},
	onLeaveCompleted: function() {
		// The Container has just been removed from the DOM.
	}
});

// ** default ** //
var pagehome = Barba.BaseView.extend({
	namespace: "pagehome",

	onEnter: function() {
		// The new Container is ready and attached to the DOM.
	},
	onEnterCompleted: function() {
		// The Transition has just finished.

		// Navbar
		document.querySelector(".header").classList.add("home");
		document.querySelector(".header-mobile").classList.add("home");
		document.querySelector(".header__logo-white").className = "header__logo";
		// document.querySelector(".header-mobile__logo-white").className =
		// 	"header-mobile__logo";

		// CTA Btn
		var allBtns = document.querySelectorAll("#main-nav .submenu .Btn");
		allBtns.forEach(function(btn) {
			btn.classList.remove("Btn-white");
		});

		// Hpi logo
		document.querySelector("#hpi").src =
			window.location.href.split(window.location.pathname)[0] +
			"/app/themes/Acolyte/assets/img/hpibet-logo-2014.png";

		var hpiLogos = document.querySelectorAll("#hpi2");

		setTimeout(function() {
			// hpi logo fix (we wait for all the submenus to be loaded)
			hpiLogos.forEach(function (hpiLogo) {
				hpiLogo.src =
					window.location.href.split(window.location.pathname)[0] +
					"/app/themes/Acolyte/assets/img/hpibet-logo-2014.png";
			});
		}, 1000);

		// add class on the body to anim the content
		setTimeout(function() {
			theBody.classList.remove("page-transition");
			theBody.classList.add("page-show");
		}, 350);
	},
	onLeave: function() {
		// A new Transition toward a new page has just started.
		setTimeout(function() {
			theBody.classList.remove("page-show");
			theBody.classList.add("page-transition");
		}, 150);
	},
	onLeaveCompleted: function() {
		// The Container has just been removed from the DOM.

		// Navbar
		document.querySelector(".header").classList.remove("home");
		// document.querySelector(".header-mobile").classList.remove("home");
		document.querySelector(".header__logo").className = "header__logo-white";

		// CTA Btn
		// var allBtns = document.querySelectorAll("#main-nav .submenu .Btn");
		// allBtns.forEach(function(btn) {
		// 	btn.classList.add("Btn-white");
		// });

		// Remove dropdown mobile

		// Hpi logo
		document.querySelector("#hpi").src =
			window.location.href.split(window.location.pathname)[0] +
			"/app/themes/Acolyte/assets/img/hpibet-logo-2014-white.png";

		var hpiLogos = document.querySelectorAll("#hpi2");
		setTimeout(function() {
			hpiLogos.forEach(function (hpiLogo) {
				hpiLogo.src =
					window.location.href.split(window.location.pathname)[0] +
					"/app/themes/Acolyte/assets/img/hpibet-logo-2014-white.png";
			});
		}, 1000);
	}
});
